import clsx from 'clsx';

import styles from '@/components/FeaturedPartners/FeaturedPartners.module.css';
import { PartnerInterface } from '@/types/homepage.types';

export interface FeaturedPartnersProps {
  data: PartnerInterface[];
  title?: string;
}

export const FeaturedPartners = ({ data, title }: FeaturedPartnersProps) => {
  const wrapperClasses = clsx(styles.wrapper);
  const headerClasses = clsx(styles.header);
  const linkContainerClasses = clsx(styles.link__container);
  const imageClasses = clsx(styles.image);

  return (
    <div className={wrapperClasses}>
      <h2 className={headerClasses}>{title || 'Our Featured Partners'}</h2>
      <div className={linkContainerClasses}>
        {data.map((dataObject) => {
          return (
            <a
              key={dataObject.name}
              href={dataObject.link}
              rel='noopener noreferrer'
              target='_blank'
              className={imageClasses}
              aria-label='Link to our featured partner website (opens in a new tab)'
            >
              <img width='120' height='120' src={dataObject.image} alt={dataObject.name} />
            </a>
          );
        })}
      </div>
    </div>
  );
};
